module.exports = __webpack_public_path__ + "static/img/4.4d61cb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pczhongfu/4.png
// module id = iE3j
// module chunks = 0